// @flow
import styled from 'styled-components'
import { Col } from 'antd'

// Default Content
export const StyledCol = styled(Col)`
 & h6 {
    font-size: 1rem;
  }
 & p { 
    font-weight: 400;
    color: #000;
    font-size: 0.75rem; 
 } 
`



// WEBPACK FOOTER //
// ./src/components/view-profile/style.js